import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { api, User, Role } from '../lib/api';

interface AuthState {
  user: User | null;
  role: Role | null;
  postCount: number;
  setUser: (u: User | null) => void;
  setRole: (r: Role | null) => void;
  loading: boolean;
}

const AuthContext = createContext<AuthState>({
  user: null,
  role: null,
  postCount: 0,
  setUser: () => {},
  setRole: () => {},
  loading: true,
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [role, setRole] = useState<Role | null>(null);
  const [postCount, setPostCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.auth.me()
      .then((res) => {
        setUser(res.data.user);
        setRole(res.data.role || null);
        setPostCount(res.data.post_count || 0);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <AuthContext.Provider value={{ user, role, postCount, setUser, setRole, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
